const urlApp = {
  verifyToken: '/sso/verify-token',
  getShareCode: '/sso/get-sharing-code',
  getCaptcha: '/captcha',
  changPasswordPath: '/customers/password',
  resetPassword: '/user/reset_password',
  //quan ly kho hang
  getListKhoHang: '/customer_address',
  postCreateListKhoHang: '/customer_address',
  postUpdateDefaultKhoHang: '/customer_address/default',
  postUpdateStatusKhoHang: '/customer_address/status',
  postUpdateKhoHang: '/customer_address/update',
  //danh sach dia chi
  listProvincePath: '/addresses/provinces',
  listDistrictPath: '/addresses/districts',
  listWardPath: '/addresses/wards',
  listStreetPath: '/addresses/street',
  // thanh toán
  getInfoCustomerPaymentPath: '/customer_payment',
  postNewListCustomerPaymentPath: '/customer_payment',
  getListBankPath: '/customer_payment/bank',
  getListBankBranchPath: '/customer_payment/bank_branch',
  // thông tin tài khoản
  getInfoCustomerPath: '/customers',
  requestOtpCustomerPhoneExistPath: '/customers/otp',
  requestOtpCustomerPhoneNewPath: '/customers/otp/new_phone',
  verifyOtpPath: '/customers/otp/verify',
  updateInfoCustomerPath: '/customers/update',
  // tạo đơn hàng
  createOrderPath: '/customer_order/create',
  createOrderNoLoginPath: '/customer_order/create_no_login',
  getAllServicePath: '/v1/api-price/getPriceAll',
  getOrderPrice: '/v1/api-price/getPrice',
  getInfoOrderPath: '/customer_order/info',
  updateInfoOrderPath: '/customer_order/update',
  // quản lý đơn hàng
  quanLyDonHangApiPath: `/customer_order`,
  updateStatusOrderPath: `/customer_order/update-status`,
  totalQuanLyDonHangApiPath: `/customer_order/count`,
  totalHeaderQuanLyDonHangApiPath: `/customer_order/count-all`,
  // tạo đơn excel
  uploadFileCreateOrderPath: '/customer_order/upload-file',
  getListHistoryFilePath: '/customer_order/file',
  getDetailHistoryFilePath: '/customer_order/file_detail',
  createOrderFilePath: '/customer_order/file/create-v1',
  createOrderFileEditPath: '/customer_order/file/create-v2',
  getInfoOrderFileDetailPath: '/customer_order/file_order',
  // cấu hình config
  configTypePath: 'utils/configs',
  // khiếu nại
  getListComplainByUserPath: 'complain/user',
  getListComplainPath: 'complain',
  getDetailComplainPath: 'complain',
  postCreateComplainPath: 'complain',
  postCloseComplainPath: 'complain/close',
  postUpdateComplainPath: 'complain/update',
  postReplyComplainPath: 'complain/detail',
  //check exist password
  existPasswordPath: 'customers/exist_password',
  // quản lý tiền hàng
  getListMoneyStatisticPath: `customer_order/statistics`,
  //upload file
  uploadFilePath: 'upload/images',
  // hành trình
  getTrackingOrderApiPath: `/customer_order/tracking`,
  //chat theo bill
  getListChatInBillPath: '/customer_order/chat',
  postChatInBillPath: '/customer_order/chat',
  //print
  getOrderPrintHashPath: '/prints',
  getInfoOrderPrintPath: '/prints/order-info',
  // dong tien
  getCusReconcilationPath: '/reconciliation',
  getCusReconcilationPaymentPath: '/reconciliation/payment-statement',
  getCusReconcilationPaymentCountPath: '/reconciliation/payment-statement/count',
  // thong bao
  getListNotiPath: '/notification/customer',
  getCountNotiPath: '/notification/customer/count',
  updateStatusNoti: '/notification/customer',
  detailNotiPath: '/notification/customer',
};

export default urlApp;
